export const mainBody = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "white"
};
